module.exports = __webpack_public_path__ + "static/media/p5_icon4.4d57c8d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/intro/p5_icon4.svg
// module id = 2529
// module chunks = 0